import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, signal, ViewChild } from '@angular/core';

@Component({
  selector: 'lib-baa-scroll-container',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (canScrollUp()) {
      <div class="pointer-events-none absolute inset-x-0 top-0 z-10 h-8 bg-gradient-to-b from-background-white to-transparent"></div>
    }
    <div #scrollEl class="mr-[-12px] flex min-h-0 flex-1 flex-col overflow-y-auto pr-3" (scroll)="onScroll()">
      <ng-content></ng-content>
    </div>
    @if (canScrollDown()) {
      <div class="pointer-events-none absolute inset-x-0 bottom-0 z-10 h-8 bg-gradient-to-t from-background-white to-transparent"></div>
    }
  `,
  host: {
    class: 'relative flex min-h-0 flex-1 flex-col',
  },
})
export class BaaScrollContainerComponent implements AfterViewInit {
  @ViewChild('scrollEl') private readonly scrollElRef!: ElementRef<HTMLElement>;

  protected readonly canScrollUp = signal(false);
  protected readonly canScrollDown = signal(false);

  public ngAfterViewInit(): void {
    // Defer so projected ng-content is fully laid out before measuring
    setTimeout(() => this.checkScroll());
  }

  protected onScroll(): void {
    this.checkScroll();
  }

  private checkScroll(): void {
    const { scrollTop, scrollHeight, clientHeight } = this.scrollElRef.nativeElement;
    this.canScrollUp.set(scrollTop > 0);
    this.canScrollDown.set(Math.ceil(scrollTop + clientHeight) < scrollHeight);
  }
}
